export default __webpack_public_path__ + "static/media/Deceiver's Belt of Ushering Twilight.d034e2d4.jpg";